import script from "./VatPurchaseBook.vue?vue&type=script&setup=true&lang=js"
export * from "./VatPurchaseBook.vue?vue&type=script&setup=true&lang=js"

import "./VatPurchaseBook.vue?vue&type=style&index=0&id=d948b340&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d948b340"]])

export default __exports__